export class Money {
  constructor(
    private amount: number,
    private fractionDigits: number = 2,
    private currency: string = "zł",
    private locales: string = "pl-PL",
    private useThreeDigitsThousandsGrouping: boolean = true
  ) {}

  /*
    toLocaleString not working on numbers less than 10000 in all browsers
    number 10000 goes as "10 000"
    however
    number 9999 goes as "9999" - no grouping

    Because of that, grroup on our own

  */
  toStringWithGrouping(number: Number): string {
    var asLocal = this.amount.toLocaleString(this.locales, {
      minimumFractionDigits: this.fractionDigits,
      maximumFractionDigits: this.fractionDigits,
    });

    if (this.useThreeDigitsThousandsGrouping) {
      asLocal = asLocal.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
    return asLocal;
  }

  toStringWithCurrency(): string {
    return typeof this.amount === "number"
      ? `${this.toStringWithGrouping(this.amount)} ${this.currency}`
      : "—";
  }
}
